'use client';

import { websiteEnv } from '@/constants/website-env';
import PaymentImages from '../payment-images';
import classes from './paymentMethod.module.css';

export const PaymentMethod = () => {
  const pageTitle = 'PAYMENT METHOD';

  return (
    <div className={classes.paymentmethod}>
      <h1 className={classes.title}>{pageTitle}</h1>
      <hr className={classes.hr} />
      <p>
        AW.Bridal ensures that your information is protected both online and offline. Our payment page is secure and
        encrypted with SSL. You can choose your preferred payment method below:
      </p>
      <h3 className={classes.subtitle}>PayPal</h3>
      <p>
        Complete your payment using your PayPal account. We strive to make the payment process simple and secure. If you
        don&apos;t have a PayPal account, you can still complete the payment using various credit/debit cards.
      </p>
      {websiteEnv.isUnitedStates ||
      websiteEnv.isCanada ||
      websiteEnv.isGermanyEnglish ||
      websiteEnv.isUnitedKingdom ||
      websiteEnv.isIreland ? (
        <>
          <h3 className={classes.subtitle}>Klarna</h3>
          <p>
            &quot;Want flexible payments?&quot; With Klarna, split your purchase into 4 interest-free installments or
            pay 30 days later—no hidden fees, no surprises.
          </p>
        </>
      ) : null}
      <p>
        If you do not have a PayPal account yet, you can still complete the payment using a wide variety of credit/debit
        cards.
      </p>
      <h3 className={classes.subtitle}>Credit Card</h3>
      <p>We accept the following credit cards:</p>
      <PaymentImages
        className='justify-start py-2'
        svgClassName='h-auto lg_w-[52px]'
      />
      <p>Note: For security reasons, we do not store any of your credit card data.</p>
    </div>
  );
};

export default PaymentMethod;
